import { render, staticRenderFns } from "./TarjetasSalud.vue?vue&type=template&id=7a4457ca&scoped=true"
import script from "./TarjetasSalud.vue?vue&type=script&lang=js"
export * from "./TarjetasSalud.vue?vue&type=script&lang=js"
import style0 from "./TarjetasSalud.vue?vue&type=style&index=0&id=7a4457ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4457ca",
  null
  
)

export default component.exports